export const buildPeriodFromFilter = ({ filter, serviceCreatedAt }) => {
  const today = new Date();

  // створюємо окремі інстанси
  let start = new Date(today);
  let end = new Date(today);

  switch (filter) {
    case "day": {
      break;
    }

    case "week": {
      start = new Date(today);
      start.setDate(start.getDate() - 7);
      break;
    }

    case "month": {
      start = new Date(today);
      start.setDate(start.getDate() - 30);
      break;
    }

    case "all": {
      // safe parsing
      if (!serviceCreatedAt) {
        return {
          start: null,
          end: new Date(today),
        };
      }

      const parsedDate = new Date(serviceCreatedAt);

      // protection from Invalid Date
      if (Number.isNaN(parsedDate.getTime())) {
        return {
          start: null,
          end: new Date(today),
        };
      }

      start = parsedDate;
      break;
    }

    default: {
      return {
        start: null,
        end: null,
      };
    }
  }

  // фінальний safeguard
  const safeStart =
    start instanceof Date && !Number.isNaN(start.getTime()) ? start : null;

  const safeEnd =
    end instanceof Date && !Number.isNaN(end.getTime()) ? end : null;

  return {
    start: safeStart,
    end: safeEnd,
  };
};
